"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _Typography = _interopRequireDefault(require("./Typography"));

var _Header = _interopRequireDefault(require("./Header"));

var _SubTitle = _interopRequireDefault(require("./SubTitle"));

var _Paragraph = _interopRequireDefault(require("./Paragraph"));

var _Remark = _interopRequireDefault(require("./Remark"));

var _Text = _interopRequireDefault(require("./Text"));

var _Count = _interopRequireDefault(require("./Count"));

for (var i = 0; i < 6; i++) {
  _Typography["default"]["H".concat(i)] = (0, _Header["default"])("h".concat(i));
}

_Typography["default"].SubTitle = _SubTitle["default"];
_Typography["default"].Paragraph = _Paragraph["default"];
_Typography["default"].Remark = _Remark["default"];
_Typography["default"].Text = _Text["default"];
_Typography["default"].Count = _Count["default"];
var _default = _Typography["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/Typography/index.js
// module id = 1206
// module chunks = 6 7 17 18